import { Avatar, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useRecordContext } from 'react-admin';
import theme from '../../../layout/theme';

export default function HardwareIcon(props: any) {
  const record = useRecordContext(props);
  let name;
  let bgcolor: any;
  let color: any;

  switch (record?.id) {
    case 1:
      name = '1';
      bgcolor = grey;
      // @ts-ignore
      color = theme.palette?.secondary?.main;
      break;
    case 2:
      name = '2';
      // @ts-ignore
      bgcolor = theme.palette?.primary?.main;
      // @ts-ignore
      color = theme.palette?.secondary?.main;
      break;
    case 3:
      name = 'P';
      // @ts-ignore
      bgcolor = theme.palette?.secondary?.main;
      // @ts-ignore
      color = theme.palette?.primary?.main;
      break;
    case 4:
      name = 'D';
      bgcolor = 'lightgrey';
      // @ts-ignore
      color = theme.palette?.secondary?.main;
      break;
    case 5:
      name = '3';
      // @ts-ignore
      bgcolor = theme.palette?.green?.main;
      // @ts-ignore
      color = theme.palette?.secondary?.main;
      break;
  }
  return (
    <Tooltip title={record?.name}>
      <Avatar
        sx={{ width: 24, height: 24, fontSize: 12, mr: '0.1rem', bgcolor: bgcolor, color: color + ' !important' }}
      >
        {name}
      </Avatar>
    </Tooltip>
  );
}
